"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentRequestModel = exports.ServiceModel = exports.LogEntryModel = exports.ContactDetailsModel = exports.CloudInputModel = exports.OnPremiseInputModel = exports.BaseInputModel = exports.newId = void 0;

var _Guard = _interopRequireDefault(require("./Guard"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const newId = () => (0, _moment.default)().format('x');

exports.newId = newId;

class BaseInputModel {
  /**
   * @type string
   */

  /**
   * 'on-premise', 'cloud' etc.
   * @type string
   */
  constructor(inputType, hostName) {
    this.hostName = void 0;
    this.inputType = inputType;
    this.hostName = hostName;
  }

}

exports.BaseInputModel = BaseInputModel;

class OnPremiseInputModel extends BaseInputModel {
  /**
   * Create an on-premise configuration
   * @param {String} hostName server host name or ip address
   * @param {String} mac NIC MAC address for the server (for licensing)
   * @param {String} serviceAccount the username for the service account
   * @param {String} [octopusHostName=null] the host name for the octopus server
   * @param {String} [octopusApiKey=null] the api key for the octopus server
   */
  constructor(hostName, mac, serviceAccount, octopusHostName, octopusApiKey) {
    super(OnPremiseInputModel.inputType, hostName);

    _Guard.default.requiresNotNull(mac, 'mac');

    _Guard.default.requiresNotNull(serviceAccount, 'serviceAccount');

    _Guard.default.requiresNotNull(octopusHostName, 'octopusHostName');

    _Guard.default.requiresNotNull(octopusApiKey, 'octopusApiKey');

    this.mac = mac;
    this.serviceAccount = serviceAccount;
    this.octopusHostName = octopusHostName;
    this.octopusApiKey = octopusApiKey;
  }

}

exports.OnPremiseInputModel = OnPremiseInputModel;
OnPremiseInputModel.inputType = 'on-premise';

class CloudInputModel extends BaseInputModel {
  constructor(domainName) {
    super(CloudInputModel.inputType, domainName);
  }

}
/**
 * Contact details for the user making the request
 */


exports.CloudInputModel = CloudInputModel;
CloudInputModel.inputType = 'cloud';

class ContactDetailsModel {
  /**
   * Collect the contact information for the user making this request
   * @param {String} uid the unique identifier for the requesting user
   * @param {String} fullName display-able full-name for this user
   * @param {String} email email address to get in contact with them
   * @param {String} phoneNumber phone number for this user
   */
  constructor(uid, fullName, email, phoneNumber) {
    _Guard.default.requiresNotNull(uid, 'uid');

    _Guard.default.requiresNotNull(fullName, 'fullName');

    _Guard.default.requiresNotNull(email, 'email');

    _Guard.default.requiresNotNull(phoneNumber, 'phoneNumber');

    this.uid = uid;
    this.fullName = fullName;
    this.email = email;
    this.phoneNumber = phoneNumber;
  }

}
/**
 * A single log entry
 */


exports.ContactDetailsModel = ContactDetailsModel;

class LogEntryModel {
  /**
   * @type string
   */

  /**
   * @type boolean
   */

  /**
   *
   * @param {String} requestId - the unique request id / status code for this environment
   * @param {String} component - name of the component sending this log message
   * @param {String} message - the message describing this event to the user (customer facing)
   * @param {String} [entryType=info] - entry type can be one of: 'info', 'success', 'error' or 'warning'
   * @param {boolean} [isReady=false] - @{true} to flag the completion of an operation (separates progress from end result)
   */
  constructor(requestId, component, message, entryType, isReady) {
    this.requestId = null;
    this.component = null;
    this.message = null;
    this.isReady = false;
    this.entryType = 'info';
    this.when = null;
    this.provisioningComplete = false;

    _Guard.default.requiresNotNull(requestId, 'requestId');

    _Guard.default.requiresNotNull(component, 'component');

    _Guard.default.requiresNotNull(message, 'message');

    this.requestId = requestId;
    this.component = component;
    this.message = message;
    this.when = (0, _moment.default)().toISOString(true);
    this.entryType = entryType || 'info';
    this.isReady = isReady === true;
  }

}

exports.LogEntryModel = LogEntryModel;

class ServiceModel {
  constructor() {
    this.log = {};
    this.endpoints = {};
    this.priceAdvertised = 0.0;
    this.licensedFeatures = [];
  }

  /**
   * Add log entry to the log
   * @param {LogEntryModel} logEntry item to append to the log
   */
  addLog(logEntry) {
    this.log[newId()] = logEntry;
  }
  /**
   * Add log entry to the log
   * @param {String} name unique id for this endpoint type
   * @param {*} endpoint an endpoint to register for this service
   */


  addEndpoint(name, endpoint) {
    this.endpoints[name] = endpoint;
  }

}
/**
 * Request instructions to provision a new environment
 */


exports.ServiceModel = ServiceModel;

class EnvironmentRequestModel {
  /**
   * The unique id for this request
   * @type {String}
   * @memberOf EnvironmentRequestModel
   */

  /**
   * Information about the hosting environment
   * @type {BaseInputModel, OnPremiseInputModel, CloudInputModel}
   * @memberOf EnvironmentRequestModel
   */

  /**
   * Contact details for the requesting user
   * @type {ContactDetailsModel}
   * @memberOf EnvironmentRequestModel
   */

  /**
   * This will hold service information for the request
   * @type ServiceModel
   */

  /**
   *
   * @param {String} requestId the unique identifier for this environment
   * @param {BaseInputModel, OnPremiseInputModel, CloudInputModel} hostEnvironment host environnment
   * @param {ContactDetailsModel} contactDetails the contact information for the user making the request
   * (see @{OnPremiseInputModel} and @{CloudInputModel}).
   */
  constructor(requestId, hostEnvironment, contactDetails) {
    this.requestId = null;
    this.hostEnvironment = null;
    this.contactDetails = null;
    this.services = null;

    _Guard.default.requiresNotNull(requestId, 'requestId');

    this.requestId = requestId;
    this.hostEnvironment = hostEnvironment;
    this.contactDetails = contactDetails;
    this.services = new ServiceModel();
    this.services.addEndpoint('service', {
      uri: hostEnvironment.hostName,
      serviceType: hostEnvironment.inputType
    });
  }

}

exports.EnvironmentRequestModel = EnvironmentRequestModel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vigilantapps/vipro-online-request-manager/dist/Models.js
// module id = AVof
// module chunks = 0